import { Component, Input, OnInit } from '@angular/core';
import { ThemeService } from 'src/@core/services/theme.service';

@Component({
  selector: 'hour4u-admin-experience-education',
  templateUrl: './experience-education.component.html',
  styleUrls: ['./experience-education.component.scss']
})
export class ExperienceEducationComponent implements OnInit {
  @Input() data: any;
  @Input() candidateDetails: any;

  constructor(
    public themeService: ThemeService
  ) { }

  ngOnInit() {
    console.log(this.candidateDetails)
  }

  calculateAverageTenure(): string { // All jobs combined 
    if (this.candidateDetails && this.candidateDetails.employment_history && this.candidateDetails.employment_history.length) {
      let totalMonths = 0;
      const now = new Date(); // Current date
      let count = this.candidateDetails.employment_history.length;

      this.candidateDetails.employment_history.forEach((job) => {
        const start = new Date(job.start_date);
        const end = job.end_date ? new Date(job.end_date) : now; // If current, use today's date

        const months = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
        totalMonths += months;
      });

      const avgMonths = totalMonths / count;
      const years = Math.floor(avgMonths / 12);
      const months = Math.round(avgMonths % 12);

      return `${years} years ${months} months`;
    }
  }

  calculateTotalExperience(): string { // Per-job duration average 
    if (this.candidateDetails && this.candidateDetails.employment_history && this.candidateDetails.employment_history.length) {
      let totalMonths = 0;
      const now = new Date(); // Current date

      this.candidateDetails.employment_history.forEach((job) => {
        const start = new Date(job.start_date);
        const end = job.end_date ? new Date(job.end_date) : now; // Use current date for ongoing jobs

        const months = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
        totalMonths += months;
      });

      const years = Math.floor(totalMonths / 12);
      const months = totalMonths % 12;

      return `${years} years ${months} months`;
    }
  }
}
